var React = require('react');

function LoaderImg (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#BFC4C6","strokeWidth":"2","d":"M12 4a8 8 0 1 1 0 16 8 8 0 0 1-8-8"}));
}

LoaderImg.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = LoaderImg;

LoaderImg.default = LoaderImg;
